import styles from '../Articles.module.scss';
import FullBackgroundImageArticleCard from 'blocks/travel-journal-articles/home/articles-card/full-background-img-article-card';
import ArticleCard from 'blocks/travel-journal-articles/home/articles-card/article-card/';
import ArticleLink from '../article-link';
import { TravelJournalArticlesType } from 'types/types';
import Container from 'components/container';

export interface ArticleGridProps {
  articles: TravelJournalArticlesType[];
  showWide?: boolean;
}

const ArticleGrid: React.FC<ArticleGridProps> = ({
  articles,
  showWide = true,
}) => {
  return (
    <Container
      as="section"
      className={`${styles.articlesGrid} ${showWide ? styles.showWide : ''}`}
    >
      {articles.map((article, index) => {
        if (!article) return null;

        const CardComponent =
          showWide && [0, 5].includes(index)
            ? FullBackgroundImageArticleCard
            : ArticleCard;

        return (
          <ArticleLink article={article} key={article.id}>
            <CardComponent article={article} />
          </ArticleLink>
        );
      })}
    </Container>
  );
};

export default ArticleGrid;
